import icons from '@assets/icons'
import SvgImage from '@components/svg'
import TableActions from '@components/table/actions'
import { theme } from '@utils'
import {
  StyleActionWrapper,
  StyleGridIconWrapper,
  StyleGridItem,
  StyleGridItems,
  StyleGridRow,
  StyleGridTitle,
} from '../style'
interface IItem {
  title?: string
  value?: string | number
  Icon?: keyof typeof icons
  onClickEdit?: () => void

  IconBg?: keyof typeof theme.colors
}
interface IGridCard {
  items?: IItem[]
}
const HelpSupportGridItem = ({ items }: IGridCard) => {
  return (
    <>
      <StyleGridItems customStyle={{ alignItem: 'center' }}>
        {items?.map(({ Icon, ...resetItem }: any, index: number) => {
          return (
            <StyleGridItem key={index}>
              <StyleGridRow>
                <StyleGridRow customStyle={{ columnGap: 20 }}>
                  <StyleGridIconWrapper bg={resetItem?.IconBg}>
                    {!!Icon && <SvgImage src={Icon} height="60%" width="60%" />}
                  </StyleGridIconWrapper>
                  <StyleGridTitle>{resetItem?.title}</StyleGridTitle>
                </StyleGridRow>
                <StyleActionWrapper>
                  <TableActions
                    hasEdit={true}
                    hasDelete={false}
                    hasView={false}
                    type="icon"
                    onEdit={resetItem?.onClickEdit}
                  />
                </StyleActionWrapper>
              </StyleGridRow>
            </StyleGridItem>
          )
        })}
      </StyleGridItems>
    </>
  )
}

export default HelpSupportGridItem
